var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIAvnAdd = function SvgIAvnAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "icon-with-background"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11,
    cx: 11,
    cy: 11,
    fill: "#0054F7",
    "data-no-stroke": "true",
    className: "i-avn__add_svg__background"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "i-avn__add_svg__inner",
    stroke: "#fff",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 5.721V15.81M5.957 10.765h10.087",
    "data-no-fill": "true"
  }))));
};
export { SvgIAvnAdd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjIgMjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS12YXJpYW50PSJpY29uLXdpdGgtYmFja2dyb3VuZCI+CiAgICA8ZyBjbGFzcz0iYmFja2dyb3VuZCI+CiAgICAgICAgPGNpcmNsZSByPSIxMSIgY3g9IjExIiBjeT0iMTEiIGZpbGw9IiMwMDU0RjciIGRhdGEtbm8tc3Ryb2tlPSJ0cnVlIi8+CiAgICA8L2c+CiAgICA8ZyBjbGFzcz0iaW5uZXIiPgogICAgICAgIDxwYXRoIGQ9Ik0xMS4wMDAzIDUuNzIxMjhWMTUuODA4OSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgICAgICA8cGF0aCBkPSJNNS45NTY4NiAxMC43NjU0SDE2LjA0NDQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgZGF0YS1uby1maWxsPSJ0cnVlIi8+CiAgICA8L2c+Cjwvc3ZnPg==";